import {
    ArrowSortUpLinesFilled,
    ArrowSortUpLinesRegular,
    ArrowSortDownLinesFilled,
    ArrowSortDownLinesRegular,
    TextSortAscendingFilled,
    TextSortAscendingRegular,
    TextSortDescendingFilled,
    TextSortDescendingRegular,
    ArrowDownExclamationFilled,
    ArrowDownExclamationRegular,
    ArrowUpExclamationFilled,
    ArrowUpExclamationRegular,
    bundleIcon,
} from '@fluentui/react-icons';
import { MailSortHelper, type SortColumn } from 'owa-mail-list-store';
import type SortDirection from 'owa-service/lib/contract/SortDirection';
import type { JSX } from 'react';

const ArrowSortUpLinesIcon = bundleIcon(ArrowSortUpLinesFilled, ArrowSortUpLinesRegular);
const ArrowSortDownLinesIcon = bundleIcon(ArrowSortDownLinesFilled, ArrowSortDownLinesRegular);
const TextSortAscendingIcon = bundleIcon(TextSortAscendingFilled, TextSortAscendingRegular);
const TextSortDescendingIcon = bundleIcon(TextSortDescendingFilled, TextSortDescendingRegular);
const ArrowDownExclamationIcon = bundleIcon(
    ArrowDownExclamationFilled,
    ArrowDownExclamationRegular
);
const ArrowUpExclamationIcon = bundleIcon(ArrowUpExclamationFilled, ArrowUpExclamationRegular);

export function getSortColumnIcon(
    sortColumn: SortColumn,
    sortDirection: SortDirection
): JSX.Element | null {
    switch (sortColumn) {
        case 1:
        case 7:
        case 16:
        case 2:
        case 17:
        case 6:
            return sortDirection === MailSortHelper.DESCENDING_SORT_DIR ? (
                <ArrowSortDownLinesIcon />
            ) : (
                <ArrowSortUpLinesIcon />
            );
        case 14:
        case 8:
        case 3:
        case 9:
            return sortDirection === MailSortHelper.DESCENDING_SORT_DIR ? (
                <TextSortDescendingIcon />
            ) : (
                <TextSortAscendingIcon />
            );
        case 5:
            return sortDirection === MailSortHelper.DESCENDING_SORT_DIR ? (
                <ArrowDownExclamationIcon />
            ) : (
                <ArrowUpExclamationIcon />
            );
        default:
            return null;
    }
}
